import constants from 'constants/constants';
import moment from 'moment-timezone';

export const BasicDateCell = ({ value }: { value?: number | null | string }) => {
    return (
        <>
            {value && typeof value === 'number' && moment(value).isValid()
                ? moment(value).format(constants.formats.date.default)
                : ''}
        </>
    );
};
